import { Service } from "../../types";

type ServiceCardProps = { service: Service };

export function ServiceCard({ service }: ServiceCardProps) {
  return (
    <article className="feature-card">
      <span className="feature-icon" aria-hidden="true" />
      <h3>{service.title}</h3>
      <p>{service.summary}</p>
      <div className="package-block">
        {service.benefits.map((benefit) => <span key={benefit}>{benefit}</span>)}
      </div>
    </article>
  );
}
